export default {
    CONTRACT: 0,
    USER_LICENSE_GDPR: 5,
    PRODUCT: 15,
    PARTNER_CONTRACT: 20,
    API_AGREEMENT: 25,
}